<div class="default-select-container">
    <label *ngIf="label">{{ label | translate }}</label>
    <select class="form-control" [(ngModel)]="selectedValue" (ngModelChange)="onSelectionChange()"
        [disabled]="disabled">

        <option *ngIf="hasPlaceholder" value="">
            {{ placeholderText | translate }}
        </option>

        <option *ngFor="let option of options" [value]="option.value">
            {{ option.translationKey ? (option.translationKey | translate) : option.label }}
        </option>

    </select>

    <div *ngIf="hasErrors" class="feedback">
        <div *ngFor="let errorKey of errorMessages">
            {{ errorKey | translate }}
        </div>
    </div>
</div>